// @flow
import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { history } from "../../../services/helpers";
import { getDashboardTickets } from "../../containers/ticketing/ticketDashboard/ticketDashboardRedux/ticketDashboardActionCreator";
import styles from "./ticketDashboardSearchBox.scss";

import BasicSelect from "../formElements/basicSelect/basicSelect";
import SearchBox from "../searchBox/searchBox";

type Props = {
  userProfile: Object,
  getDashboardTickets: Function,
  ticketDashboardState: Object
};

type State = {
  selectedOption: String,
  searchText: String,
  selectedOptionKey: String
};

class TicketDashboardSearchBox extends React.Component<Props, State> {
  constructor(props: Object) {
    super(props);
    this.state = {
      selectedOption: "",
      searchText: null,
      selectedOptionKey: null
    };
  }

  onTicketDashBoardSelect(val, event) {
    this.setState({
      selectedOption: (event && event.val) || val,
      selectedOptionKey: (event && event.option) || val
    });
  }

  onTicketDashBoardSearch(val) {
    this.setState({
      searchText: val
    });
  }

  onKeyPress(event) {
    if (event.key === "Enter") {
      if (this.state.selectedOption && this.state.searchText) {
        this.props.getDashboardTickets({
          label: "Search",
          apiEndPoint: "getTicketsSearch",
          key: this.state.selectedOptionKey,
          val: this.state.searchText
        });
      }
    }
  }

  getSearchOptions() {
    const arr = this.props.ticketDashboardState.searchOptions.data || [];
    return arr.map(option => ({
      key: option.key,
      val: option.key,
      option: option.val
    }));
  }

  showTicketDashboardSearch() {
    // history.location.pathname is the current url
    // history.location.pathname = "/ticketdashboard"
    if (history.location.pathname.split("/")[1] === "ticketdashboard") {
      return true;
    }
    return false;
  }

  render() {
    return (
      <div className={styles.ticketDashboardSearchWrapper}>
        <div className="l-row">
          <div className={styles.selectWrapper}>
            <BasicSelect
              optionsArrOfObj={this.getSearchOptions()}
              label="Select"
              onSelect={(val, event) =>
                this.onTicketDashBoardSelect(val, event)
              }
              passEvent={true}
            />
          </div>
          <div className={styles.searchWrapper}>
            <SearchBox
              onSearchValueChange={val => this.onTicketDashBoardSearch(val)}
              resetSearchText={false}
              onKeyPress={val => this.onKeyPress(val)}
            />
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  ticketDashboardState: state.ticketDashboardState,
  userProfile: state.userProfile
});

const mapDispatchToProps = dispatch => ({
  getDashboardTickets: bindActionCreators(getDashboardTickets, dispatch)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TicketDashboardSearchBox);



// WEBPACK FOOTER //
// ./app/components/commons/ticketDashboardSearchBox/ticketDashboardSearchBox.js